import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import BlogCard from "./BlogCard";
const Blog = () => {
  return (
    <>
      <Helmet>
        <title>Navishaa Blog: Latest Digital Marketing News & Insights.</title>

        {/* Description */}
        <meta
          name="description"
          content="Stay updated with Navishaa experts’ tips, trends, and insights on digital marketing. Explore strategies, news, and advice to grow your business online."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.navishaa.com/blog" />

        {/* Open Graph (OG) tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="   Navishaa Blog: Latest Digital Marketing News & Insights."
        />
        <meta
          property="og:description"
          content="Stay updated with Navishaa experts’ tips, trends, and insights on digital marketing. Explore strategies, news, and advice to grow your business online."
        />
        <meta property="og:url" content="https://www.navishaa.com/blog" />
        <meta property="og:site_name" content="navishaa" />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/career-opportunities-banner.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="629" />

        {/* Twitter tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@navishaa" />
        <meta
          name="twitter:title"
          content="Navishaa Blog: Latest Digital Marketing News & Insights."
        />
        <meta
          name="twitter:description"
          content="Stay updated with Navishaa experts’ tips, trends, and insights on digital marketing. Explore strategies, news, and advice to grow your business online."
        />
        <meta
          name="twitter:image"
          content="https://www.navishaa.com//images/career-opportunities-banner.png"
        />

        {/* LinkedIn tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.navishaa.com/blog" />
        <meta
          property="og:title"
          content="Navishaa Blog: Latest Digital Marketing News & Insights."
        />
        <meta
          property="og:description"
          content="Stay updated with Navishaa experts’ tips, trends, and insights on digital marketing. Explore strategies, news, and advice to grow your business online."
        />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/blog-banner.png"
        />

        {/* Structured Data - Schema.org */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Navishaa Blog: Latest Digital Marketing News & Insights.",
        "author": {
          "@type": "Person",
          "name": "Navishaa"
        },
        "datePublished": "2023-09-05",
        "dateModified": "2023-09-05",
        "image": {
          "@type": "ImageObject",
          "url": "https://www.navishaa.com/images/social-banner.png",
          "width": 1200,
          "height": 629
        },
        "publisher": {
          "@type": "Organization",
          "name": "Navishaa",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.navishaa.com//images/logo.png",
            "width": 1854,
            "height": 503
          }
        },
        "mainEntityOfPage": "https://www.navishaa.com/blog",
        "url": "https://www.navishaa.com/blog",
        "description": "Stay updated with Navishaa experts’ tips, trends, and insights on digital marketing. Explore strategies, news, and advice to grow your business online."
      }
    `}
        </script>
      </Helmet>
      <section className="relative w-full h-[400px] pt-24 pb-10   flex items-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://res.cloudinary.com/dbitupkaa/image/upload/v1758620734/10601_hero_image_fqo06r.jpg')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-purple-900/70 via-purple-800/40 to-purple-900/70"></div>
        </div>

        {/* Content */}
        <div className="relative  z-10 w-full max-w-6xl mx-auto px-6 lg:px-20 flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-between h-full">
          {/* Left Text */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left lg:w-1/2"
          >
            <h1 className="text-3xl  lg:text-5xl font-bold text-white mb-4 leading-snug">
              Blog
            </h1>
            <p className="text-lg lg:text-xl text-white/90 mb-6">
              Get the latest digital marketing news, tips, and insights from
              GetMax experts.
            </p>
            <button className="px-6 py-3 bg-gradient-to-r from-purple-500 to-purple-700 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transform transition">
              Explore Articles
            </button>
          </motion.div>

          {/* Right Side Image (Optional or Decorative) */}
          <div className="hidden lg:block lg:w-1/2 h-full">
            <img
              src="https://res.cloudinary.com/dbitupkaa/image/upload/v1758620734/10601_hero_image_fqo06r.jpg"
              alt="Blog Hero"
              className="w-full h-full object-cover rounded-lg shadow-xl"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <BlogCard />
    </>
  );
};

export default Blog;
